module.exports = __webpack_public_path__ + "static/img/paixu02.cb79305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/paixu02.png
// module id = 114
// module chunks = 0